import { render, staticRenderFns } from "./CarritoCompra.vue?vue&type=template&id=72f3fcd5"
import script from "./CarritoCompra.vue?vue&type=script&lang=js"
export * from "./CarritoCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports